import { StyledGrid } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledRoomsGrid = styled(StyledGrid)`
  margin-bottom: 2.4rem;
`;
